var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinanceRafiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-56"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 388.78,
    width: 23.18,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.1,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.72,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.3,
    y: 92.14,
    width: 265.52,
    height: 144.23,
    transform: "translate(492.12 328.5) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.29,
    y: 92.14,
    width: 265.52,
    height: 144.23,
    transform: "translate(486.09 328.5) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.01,
    y: 36.91,
    width: 132.07,
    height: 254.69,
    transform: "translate(407.3 -78.8) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.81,
    y: 163.11,
    width: 132.07,
    height: 2.28,
    transform: "translate(281.09 47.41) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.53,
    y: 198.99,
    width: 261.04,
    height: 8.16,
    transform: "translate(486.09 406.15) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.53,
    y: 129.66,
    width: 261.04,
    height: 8.16,
    transform: "translate(486.09 267.48) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.39,82.07H384.72a.84.84,0,0,1,.83.84h0a.83.83,0,0,1-.83.83H104.39a.84.84,0,0,1-.84-.83h0A.85.85,0,0,1,104.39,82.07Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.39,82.91a4.17,4.17,0,1,0,4.16-4.17A4.16,4.16,0,0,0,99.39,82.91Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.7,87.57h0a1.12,1.12,0,0,0,1.12-1.12V84a1.12,1.12,0,0,0-1.12-1.12h0A1.13,1.13,0,0,0,376.57,84v2.42A1.13,1.13,0,0,0,377.7,87.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,87.57h0a1.13,1.13,0,0,0,1.13-1.12V84A1.13,1.13,0,0,0,117,82.91h0A1.12,1.12,0,0,0,115.83,84v2.42A1.12,1.12,0,0,0,117,87.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.65,
    y: 82.91,
    width: 268.91,
    height: 30.28,
    transform: "translate(478.22 196.1) rotate(180)",
    style: {
      fill: "#e0e0e0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.29,
    cy: 82.91,
    r: 4.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.89,
    y: 268.35,
    width: 17.06,
    height: 114.04,
    transform: "translate(608.84 650.75) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.38 382.4 295.89 382.4 295.89 366.87 305.08 366.87 300.38 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.43,
    y: 268.35,
    width: 17.06,
    height: 114.04,
    transform: "translate(885.92 650.75) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.89,
    y: 268.35,
    width: 142.45,
    height: 104.51,
    transform: "translate(734.23 641.22) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.37,
    y: 272.99,
    width: 135.49,
    height: 28.66,
    transform: "translate(734.23 574.63) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,281.89H405c4.37,0,8.56-3.53,11.57-9.78H314.68C317.69,278.36,321.87,281.89,326.25,281.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.86 382.4 438.34 382.4 438.34 366.87 429.15 366.87 433.86 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.37,
    y: 306.28,
    width: 135.49,
    height: 28.66,
    transform: "translate(734.23 641.22) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,315.19H405c4.37,0,8.56-3.54,11.57-9.78H314.68C317.69,311.65,321.87,315.19,326.25,315.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.37,
    y: 339.57,
    width: 135.49,
    height: 28.66,
    transform: "translate(734.23 707.81) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,348.48H405c4.37,0,8.56-3.54,11.57-9.78H314.68C317.69,344.94,321.87,348.48,326.25,348.48Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.22,211.18c-2.7-9.09,30.93-54.57,45.69-53.21s-11.19,56.53-19.16,61.41C416.76,224.89,402.16,221.07,399.22,211.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.29,224.29c-1.3-4.64,22.21-12.19,31.55-6.72s-9.73,19.56-15,18.92C407.83,235.77,398.71,229.34,397.29,224.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.85,220.13c3.25-6.1-20.69-41.73-33.45-42.39s3.63,41,9.92,45.27C409.43,227.86,422.3,226.76,425.85,220.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,201.17h-.05a2.51,2.51,0,0,0-2.52,2.13,221,221,0,0,0-1,56.76,2.5,2.5,0,0,0,2.44,2.21h.05a2.49,2.49,0,0,0,2.51-2.77A220.54,220.54,0,0,1,416,204,2.48,2.48,0,0,0,413.58,201.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.75,268.35h0c8.84,0,16.29-5.2,18.1-12.25a28.57,28.57,0,0,1,1.89-5.47l.14-.29H391.62l.14.29a28.57,28.57,0,0,1,1.89,5.47C395.46,263.15,402.92,268.35,411.75,268.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.54,252.11H432c1.13,0,2.11-1.1,2.39-2.68h0c.4-2.27-.78-4.47-2.39-4.47H391.54c-1.61,0-2.79,2.2-2.38,4.47h0C389.44,251,390.42,252.11,391.54,252.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 310.56,
    width: 49.81,
    height: 71.84,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.96,
    y: 310.56,
    width: 148.14,
    height: 71.84,
    transform: "translate(286.07 692.96) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.98,
    y: 334.61,
    width: 31.32,
    height: 31.89,
    transform: "translate(195.28 701.1) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 334.61,
    width: 31.32,
    height: 31.89,
    transform: "translate(280.32 701.1) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.44,
    y: 318.2,
    width: 198.47,
    height: 4.09,
    style: {
      fill: "#e6e6e6",
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.1,
    y: 308.08,
    width: 52.56,
    height: 11.85,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.21,
    y: 308.08,
    width: 150.89,
    height: 11.85,
    transform: "translate(283.32 628) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9,287.91s.95,20.17,37.3,20.17,37.3-20.17,37.3-20.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9,274.55s.95,20.17,37.3,20.17,37.3-20.17,37.3-20.17Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-56"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-56",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.15,
    y: 394.46,
    width: 98.19,
    height: 18.48,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.15,
    y: 394.46,
    width: 98.19,
    height: 2.1,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.34,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.22,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.11,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.99,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.87,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.76,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.64,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.52,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.41,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.29,
    y: 394.46,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.16,
    y: 375.98,
    width: 98.19,
    height: 18.48,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.16,
    y: 375.98,
    width: 98.19,
    height: 2.1,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.34,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.23,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.11,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.99,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.88,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.76,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.64,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.53,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.41,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.29,
    y: 375.98,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 357.5,
    width: 98.19,
    height: 18.48,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 357.5,
    width: 98.19,
    height: 2.1,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.52,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.29,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.17,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.05,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.94,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.7,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.59,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.47,
    y: 357.5,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 339.03,
    width: 98.19,
    height: 18.48,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.78,
    y: 339.03,
    width: 98.19,
    height: 2.1,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.96,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.85,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.73,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.61,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.38,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.26,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.15,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.03,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.91,
    y: 339.03,
    width: 3.87,
    height: 18.48,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 320.55,
    width: 98.19,
    height: 18.48,
    transform: "translate(271.12 659.57) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 320.55,
    width: 98.19,
    height: 2.1,
    transform: "translate(271.12 643.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(351.07 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.72,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(333.3 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.83,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(315.53 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.95,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(297.77 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.07,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(280 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.18,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(262.23 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.3,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(244.47 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.42,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(226.7 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.53,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(208.93 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.65,
    y: 320.55,
    width: 3.87,
    height: 18.48,
    transform: "translate(191.17 659.57) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.46,
    y: 302.07,
    width: 98.19,
    height: 18.48,
    transform: "translate(279.11 622.62) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.46,
    y: 302.07,
    width: 98.19,
    height: 2.1,
    transform: "translate(279.11 606.24) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.6,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(359.06 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.71,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(341.3 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.83,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(323.53 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.95,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(305.76 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.06,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(288 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.18,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(270.23 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.3,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(252.46 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(234.7 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.53,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(216.93 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.65,
    y: 302.07,
    width: 3.87,
    height: 18.48,
    transform: "translate(199.16 622.62) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.28,
    y: 283.59,
    width: 98.19,
    height: 18.48,
    transform: "translate(284.76 585.66) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.28,
    y: 283.59,
    width: 98.19,
    height: 2.1,
    transform: "translate(284.76 569.28) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.42,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(364.71 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.54,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(346.94 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.65,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(329.17 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(311.41 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.89,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(293.64 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(275.87 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.12,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(258.11 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.24,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(240.34 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.35,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(222.57 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.47,
    y: 283.59,
    width: 3.87,
    height: 18.48,
    transform: "translate(204.81 585.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.84,
    y: 265.11,
    width: 98.19,
    height: 18.48,
    transform: "translate(275.87 548.7) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.84,
    y: 265.11,
    width: 98.19,
    height: 2.1,
    transform: "translate(275.87 532.32) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.98,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(355.82 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.09,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(338.06 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.21,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(320.29 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.33,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(302.52 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.44,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(284.76 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.56,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(266.99 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.68,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(249.22 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.79,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(231.46 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.91,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(213.69 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.03,
    y: 265.11,
    width: 3.87,
    height: 18.48,
    transform: "translate(195.92 548.7) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Growth--inject-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.66,192l-39.16,6.71a3.85,3.85,0,0,0-1.57,6.95l7.22,5.11-44.27,62.58a3.79,3.79,0,0,1-5.29.9l-65.07-46a3.81,3.81,0,0,0-5.3.91L116.05,414.56h47.14l93.23-131.79a3.79,3.79,0,0,1,5.29-.9l65.07,46a3.8,3.8,0,0,0,5.3-.91l66.49-94,7.23,5.11a3.86,3.86,0,0,0,6-3.8l-6.72-39.16A3.85,3.85,0,0,0,400.66,192Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.66,192l-39.16,6.71a3.85,3.85,0,0,0-1.57,6.95l7.22,5.11-44.27,62.58a3.79,3.79,0,0,1-5.29.9l-65.07-46a3.81,3.81,0,0,0-5.3.91L116.05,414.56h47.14l93.23-131.79a3.79,3.79,0,0,1,5.29-.9l65.07,46a3.8,3.8,0,0,0,5.3-.91l66.49-94,7.23,5.11a3.86,3.86,0,0,0,6-3.8l-6.72-39.16A3.85,3.85,0,0,0,400.66,192Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.24,409.11H127.06a.26.26,0,0,1-.22-.14.25.25,0,0,1,0-.26l121.52-171.8a4.05,4.05,0,0,1,5.65-1l65.06,46a3.55,3.55,0,0,0,5-.85l50.71-71.68-8-5.69a.23.23,0,0,1-.1-.26.25.25,0,0,1,.2-.19l33-5.65a.24.24,0,0,1,.28.2l5.65,33a.27.27,0,0,1-.11.26.26.26,0,0,1-.28,0l-8-5.69-66.35,93.8a4.05,4.05,0,0,1-5.64,1l-65.07-46a3.55,3.55,0,0,0-4.95.85L160.45,409A.26.26,0,0,1,160.24,409.11Zm-32.7-.5h32.57l94.74-133.93a4.06,4.06,0,0,1,5.65-1l65.07,46a3.55,3.55,0,0,0,4.95-.85l66.49-94a.21.21,0,0,1,.16-.1.22.22,0,0,1,.19,0l7.75,5.48L399.6,198.2l-32.11,5.5,7.75,5.48a.27.27,0,0,1,.1.16.25.25,0,0,1,0,.19l-50.85,71.89a4,4,0,0,1-2.62,1.65,4.07,4.07,0,0,1-3-.68l-65.06-46a3.55,3.55,0,0,0-5,.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.94,
    y: 351.79,
    width: 4.11,
    height: 61.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.9,
    y: 318.47,
    width: 4.11,
    height: 94.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.52,
    y: 341.13,
    width: 4.11,
    height: 71.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.13,
    y: 351.79,
    width: 28.82,
    height: 61.15,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.13 351.79 315.13 388.05 329.53 351.79 315.13 351.79",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.08,
    y: 318.47,
    width: 28.82,
    height: 94.47,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.08 318.47 351.08 354.73 365.49 318.47 351.08 318.47",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.71,
    y: 341.13,
    width: 28.82,
    height: 71.81,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.71 341.13 387.71 373.4 402.12 341.13 387.71 341.13",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "248.08 407.94 240.35 406.49 241.66 388.2 249.39 389.66 248.08 407.94",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.1 407.73 292.23 407.73 290.28 389.52 298.14 389.52 300.1 407.73",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.59,406.82h9.58a.69.69,0,0,1,.67.54l1.56,7a1.16,1.16,0,0,1-1.15,1.4c-3.09-.05-5.34-.24-9.22-.24-2.39,0-9.6.25-12.9.25s-3.73-3.26-2.38-3.56c6.06-1.32,10.62-3.15,12.56-4.89A1.9,1.9,0,0,1,291.59,406.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,404.79l8.47,1.46a.69.69,0,0,1,.57.64l.34,7.15a1.15,1.15,0,0,1-1.35,1.19c-3-.58-7.43-1.52-11.26-2.18-4.49-.77-6.68-1.33-11.94-2.24-3.18-.55-2.49-4-1.1-4.09,6.29-.28,8.51.68,14.3-1.65A3.63,3.63,0,0,1,240.51,404.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,167.09c-.27.8-.48,1.38-.73,2s-.5,1.28-.76,1.91c-.52,1.27-1.07,2.51-1.65,3.75a72.47,72.47,0,0,1-3.89,7.25,47.81,47.81,0,0,1-11.27,13.08,27.68,27.68,0,0,1-4,2.54c-.36.2-.73.37-1.11.54s-.72.33-1.17.5a16.11,16.11,0,0,1-2.73.74,28,28,0,0,1-4.57.39c-1.44,0-2.82,0-4.18-.13a80,80,0,0,1-15.67-2.84l.79-5.85c5-.19,10.07-.35,14.83-.77,1.19-.11,2.36-.25,3.47-.42a18.84,18.84,0,0,0,3-.66,4.4,4.4,0,0,0,.92-.38c.33-.2.78-.39,1.15-.65a18,18,0,0,0,2.31-1.73,29.72,29.72,0,0,0,4.29-4.72,52.82,52.82,0,0,0,3.74-5.73c1.17-2,2.22-4.13,3.25-6.27.5-1.07,1-2.16,1.44-3.25l.67-1.63.61-1.54Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,157.87c14.35,0-1.42,31-1.42,31l-18.31-7.41s5-10.78,8.29-16.95A12.19,12.19,0,0,1,263.65,157.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.65,157.87c14.35,0-1.42,31-1.42,31l-18.31-7.41s5-10.78,8.29-16.95A12.19,12.19,0,0,1,263.65,157.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.14,167.89c-5.25,3.69-8.9,10.54-9.94,16.1l10.46,4.24c1.9-2.84,3.75-6.19,5.79-9.13.56-1.53,1.11-3.14,1.59-4.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,191.72l-6.29-3.55-4.82,9a21.92,21.92,0,0,0,8.39-.21Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.69 188.17 205.19 196.11 209.85 197.2 214.67 188.17 208.69 188.17",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.66 388.21 240.99 397.63 248.72 399.08 249.39 389.66 241.66 388.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.14 389.53 290.27 389.53 291.29 398.92 299.15 398.92 298.14 389.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,161.3a177.3,177.3,0,0,0-5,25.87c-.75,6.09-1.19,11.9-1.47,17.18-.66,12.36-.38,21.78-.75,25-6.15-.42-29.32-2-42-2.92-5.71-44.73,5.2-67.77,5.2-67.77a82.06,82.06,0,0,1,10-1.25c.71,0,1.44-.07,2.17-.08a155.11,155.11,0,0,1,17.84,1.24c1.12.13,2.26.3,3.36.48C297.84,159.93,302.78,161.3,302.78,161.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.78,161.3a177.3,177.3,0,0,0-5,25.87c-.75,6.09-1.19,11.9-1.47,17.18-.66,12.36-.38,21.78-.75,25-6.15-.42-29.32-2-42-2.92-5.71-44.73,5.2-67.77,5.2-67.77a82.06,82.06,0,0,1,10-1.25c.71,0,1.44-.07,2.17-.08a155.11,155.11,0,0,1,17.84,1.24c1.12.13,2.26.3,3.36.48C297.84,159.93,302.78,161.3,302.78,161.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.19,172.62a33,33,0,0,0,5.19,18.18c.12-1.2.26-2.41.41-3.63.56-4.58,1.28-9.32,2.23-14.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.49,138.33c-1.52,5.67-3.38,16.1.37,20.21a17.88,17.88,0,0,1-14.14,4.51c-4.93-.45-4.93-3.92-3.7-5.75,6.51-1.08,6.67-5.84,5.87-10.38Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.11,164.92a12.79,12.79,0,0,0,.62,2.59,1.32,1.32,0,0,0,1.26.92,12.3,12.3,0,0,1,2.45.21,1.28,1.28,0,0,0,1-.18c1-.63,2.28-1.56,1.95-2.72-.39-1.36-2.73-2.59-2.73-2.59S271.64,164.14,271.11,164.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.22,167.51c-1.61,3.52-5.33,26.06-5.79,29.47s1.11,8.91,3.29,13.28a21.44,21.44,0,0,0,4.1-11.79c.29-4.66.57-30.4.57-30.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.63,163.15a14.79,14.79,0,0,1,3.62,4.48c2.53-.2,13.7-5.1,12.11-8.88-1.39-.39-2.61-1.19-3-.78C287.83,158.78,283.09,161.64,275.63,163.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.63,163.15s-4.29,1.45-5.29,3.89c-2.59-1.15-4-6.34-1.71-9.75,1.43-.12,2.8-.83,3.06-.36C272.09,157.82,271,160.21,275.63,163.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.76,141.84l-6.87,5.07a17.75,17.75,0,0,1,.33,3.21c2.47-.18,6-2.63,6.46-5.17A8.5,8.5,0,0,0,283.76,141.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.83,120.12c-3,1.18-4.11,12.79,2,11.65S277.87,117.75,271.83,120.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,131.73c-2.45,7.41-3.5,11.87-8.32,14.74-7.26,4.31-15.65-1.59-15.47-9.58.16-7.19,4.13-18.11,12.3-19.16A10.64,10.64,0,0,1,291.64,131.73Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.86,136.83c-3.11.06-5.66-9.36.61-12-4.94-.57-20.11.26-22.83-6.52s7.83-7.83,11.42-5.27c-1.14-3.73,3.5-9.23,11.84-4.23s8.24,11.17,7.46,13c3.72,1,4.45,9.28.34,10.39,2.41,3.34.33,10.36-6.17,8.86-.22,4.09-4.78,2.3-4.5-.84S288.86,136.83,288.86,136.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,138.64h0a5.75,5.75,0,0,0,5.17-1,.21.21,0,0,0,0-.29.2.2,0,0,0-.28,0,5.41,5.41,0,0,1-4.8,1,.19.19,0,0,0-.24.14A.19.19,0,0,0,275,138.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.19,139.59a7.45,7.45,0,0,1-5.31,2c-2.6-.11-3.1-2.63-1.71-4.66,1.26-1.83,4.12-4,6.4-2.89A3.33,3.33,0,0,1,293.19,139.59Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.38,394.58l13,3.07s4.6-50.65,8.55-78.48c1.05-7.38,2.67-17.76,5.14-28.82,3.11-13.93,7-29,10.22-40.8,3.37-12.43,5.94-21.22,5.94-21.22l-27.58-1.93s-14.93,65.1-16.51,89C235.45,340.34,238.38,394.58,238.38,394.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,290.35c3.11-13.93,7-29,10.22-40.8l-2.87-6.17C265.54,251.51,263.7,276.68,265,290.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,227.44s3,67.32,6.3,90.12c3.63,25,12.86,79.54,12.86,79.54h14.41s-4-51.87-6.71-76.32c-3.09-27.85.21-91.45.21-91.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.93 397.41 302.89 397.41 303.64 392.34 284.92 392.01 285.93 397.41",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.55 395.45 252.32 398.23 253.99 393.08 237.15 389.89 237.55 395.45",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.25,131.14c-.17.61-.62,1-1,.92s-.6-.69-.44-1.3.62-1,1-.92S280.41,130.53,280.25,131.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,129.32c-.16.61-.62,1-1,.91s-.59-.68-.43-1.3.62-1,1-.92S273.47,128.7,273.31,129.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.85,129.89a23,23,0,0,1-4.31,4.48c.81,1.29,2.9,1.18,2.9,1.18Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4,129.15a.37.37,0,0,1-.32-.23,3,3,0,0,0-2-1.81.37.37,0,1,1,.14-.73,3.7,3.7,0,0,1,2.54,2.26.37.37,0,0,1-.2.49A.35.35,0,0,1,282.4,129.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.38,125.84a.4.4,0,0,1-.21-.09.37.37,0,0,1,0-.53,3.7,3.7,0,0,1,3.12-1.35.39.39,0,0,1,.32.42.38.38,0,0,1-.42.32h0a3,3,0,0,0-2.46,1.1A.38.38,0,0,1,270.38,125.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,408.2a2.4,2.4,0,0,1-1.52-.4,1.12,1.12,0,0,1-.38-1,.56.56,0,0,1,.32-.52c.87-.45,3.4,1.11,3.69,1.29a.17.17,0,0,1,.08.18.18.18,0,0,1-.14.16A9.31,9.31,0,0,1,289,408.2Zm-1.17-1.63a.43.43,0,0,0-.24.05c-.05,0-.11.07-.12.22a.75.75,0,0,0,.25.67,3.79,3.79,0,0,0,2.79.14A7.52,7.52,0,0,0,287.82,406.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,407.92l-.09,0c-.81-.44-2.39-2.17-2.22-3a.61.61,0,0,1,.59-.49,1,1,0,0,1,.8.24c.91.74,1.1,3,1.11,3.11a.2.2,0,0,1-.09.17A.17.17,0,0,1,291,407.92Zm-1.59-3.19h-.08c-.24,0-.26.14-.27.19-.1.51.9,1.82,1.71,2.43a4.41,4.41,0,0,0-.93-2.46A.65.65,0,0,0,289.41,404.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,405.73h0c-1.29,0-3.56-.05-4.28-.94a1.05,1.05,0,0,1-.19-1,.59.59,0,0,1,.38-.43c1-.35,3.88,1.75,4.2,2a.17.17,0,0,1,.06.2A.19.19,0,0,1,239.57,405.73Zm-3.94-2h0a.22.22,0,0,0-.15.18.67.67,0,0,0,.12.62c.4.51,1.66.8,3.42.81C237.83,404.56,236.23,403.61,235.63,403.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,405.73a.19.19,0,0,1-.14,0c-.86-.58-2.42-2.58-2.13-3.43.07-.2.26-.43.77-.4a1.39,1.39,0,0,1,1,.49c.85,1,.7,3.11.69,3.2a.18.18,0,0,1-.1.15Zm-1.74-3.47c-.14,0-.17.1-.18.13-.17.51.86,2.05,1.71,2.78a4.29,4.29,0,0,0-.61-2.56,1,1,0,0,0-.7-.36A.49.49,0,0,0,237.83,402.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.11,196.42l-3.19-2.28-52.3,73.21,3.19,2.28a45,45,0,0,0,52.3-73.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.11,196.42l-3.19-2.28-52.3,73.21,3.19,2.28a45,45,0,0,0,52.3-73.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,236.47A48.34,48.34,0,0,1,191,218l1,.26a47.18,47.18,0,0,0-1.32,18.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.68,248.54a48.54,48.54,0,0,1-2.15-7l1-.22a48.26,48.26,0,0,0,2.11,6.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.77,
    cy: 230.75,
    r: 44.98,
    transform: "translate(-41.65 52.7) rotate(-11.64)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.15,242.12l7.06-9.87q-3.68-4.62-3.93-8.84a12.36,12.36,0,0,1,2.49-8,11.31,11.31,0,0,1,7.08-4.75,12.12,12.12,0,0,1,8.66,1.61l1.7-2.38,3.42,2.44-1.71,2.38a12.43,12.43,0,0,1,4.14,6.82,12.18,12.18,0,0,1-1.2,7.67l-6.52-3.48a5.93,5.93,0,0,0-.14-5.8l-6.58,9.22q4.56,5.58,4.87,9.48a11.55,11.55,0,0,1-2.42,7.72,12.87,12.87,0,0,1-7.72,5.35,14,14,0,0,1-9.74-1.54l-1.7,2.38-3.42-2.44,1.62-2.27a13.38,13.38,0,0,1-4.45-7.77,15.37,15.37,0,0,1,1.88-9.52l6.63,3.74a9.61,9.61,0,0,0-.91,4.26A8,8,0,0,0,227.15,242.12Zm17.68-24.75a5.43,5.43,0,0,0-3.36,0,5.09,5.09,0,0,0-2.61,1.91,4.91,4.91,0,0,0-.9,2.86,6.39,6.39,0,0,0,1,3.37Zm-14.5,27.53a5.89,5.89,0,0,0,4,.41,5.67,5.67,0,0,0,3.31-2.28,5.15,5.15,0,0,0,1-3.39,7.36,7.36,0,0,0-1.8-3.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.21,227a36.64,36.64,0,0,0-72.15,12,36.64,36.64,0,1,1,72.15-12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.79,165.6c1,1.27,1.83,2.41,2.67,3.65s1.66,2.43,2.46,3.67c1.59,2.48,3.1,5,4.5,7.63s2.7,5.32,3.88,8.1l.86,2.11.78,2.17c.26.71.48,1.47.71,2.21l.33,1.12.09.28.15.61a9.41,9.41,0,0,1,.2,1.26,10.63,10.63,0,0,1-.55,4.16,14.86,14.86,0,0,1-1.35,2.88,26.33,26.33,0,0,1-3.16,4.16,55.81,55.81,0,0,1-6.85,6.17,100.53,100.53,0,0,1-14.82,9.39l-3.24-4.94c4.19-3.57,8.38-7.33,12.17-11.14a55.16,55.16,0,0,0,5.12-5.84,16.06,16.06,0,0,0,1.72-2.77,5.09,5.09,0,0,0,.34-1c0-.22,0-.26,0,0a.55.55,0,0,0,0,.22.66.66,0,0,0,0,.09l-.09-.22-.35-.88c-.24-.6-.45-1.19-.73-1.78l-.8-1.77-.85-1.77c-1.19-2.35-2.46-4.69-3.84-7s-2.81-4.61-4.3-6.87c-.73-1.14-1.49-2.27-2.25-3.38l-2.28-3.25Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,161.3c7.37,1.49,13.84,19.51,13.84,19.51l-15.38,12.53s-5-9.16-9.08-18C287.77,165.71,293.85,159.5,302.78,161.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.78,161.3c7.37,1.49,13.84,19.51,13.84,19.51l-15.38,12.53s-5-9.16-9.08-18C287.77,165.71,293.85,159.5,302.78,161.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.27,219.54l-7.94.87,5.15,8.62s6.6-2.24,5.8-5.86Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.6 224.96 284.19 231.89 289.48 229.03 284.33 220.41 279.6 224.96",
    style: {
      fill: "#7f3e3b"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceRafiki);
export default __webpack_public_path__ + "static/media/Finance-rafiki.628e89c45b30ab5af3f82feffc72663a.svg";
export { ForwardRef as ReactComponent };